module.exports = __webpack_public_path__ + "img/award.d809f3ba.svg";